module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile",
    class: {
      'new': typeof _vm.tile === 'string', 'merged': _vm.merged
    },
    style: (_vm.style)
  }, [_vm._v("\r\n" + _vm._s(_vm.tile ? _vm.tile : '') + "\r\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-070c3281"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/gamecontainer/tiles/tile.vue
// module id = 33
// module chunks = 0